import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.png";
import logo_mob from "../img/logo.png";
import MobileMenu from "./MobileMenu";
import Fade from 'react-reveal/Fade';

function Header() {

    const [rinki, setRinki] = useState(false);
    const [torgi, setTorg] = useState(false);

    const { t } = useTranslation();
    const location = useLocation();

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'ru', label: 'RU' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    const closeMenus = () => {
        setRinki(false);
        setTorg(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            closeMenus();
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        closeMenus();
    }, [location]);

    const handleRinkiClick = () => {
        setRinki(prevState => {
            if (!prevState) {
                setTorg(false);
            }
            return !prevState;
        });
    };

    const handleTorgClick = () => {
        setTorg(prevState => {
            if (!prevState) {
                setRinki(false);
            }
            return !prevState;
        });
    };

    return (
        <div className="header-container fixed z-[100] w-full bg-[#FFFFFF]">
            <div className="hidden max-w-[1220px] h-[100px] justify-between mx-auto xl:flex items-center">
                <Link to="/"><img src={logo} alt="" className="w-[97px] hover:scale-[0.9] transition-all"/></Link>
                <div className="flex items-center gap-[30px]">
                    <div>
                        <div className="flex gap-[6px] cursor-pointer hover:scale-[1.1] transition-all" onClick={handleRinkiClick}>
                            <p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/###' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2')}</p>
                            <svg className={`mt-px transition-all ${rinki === true ? 'rotate-90' : ''}`} xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
                                <path d="M2.45199 6.58L3.51299 5.52L9.29199 11.297C9.38514 11.3896 9.45907 11.4996 9.50952 11.6209C9.55997 11.7421 9.58594 11.8722 9.58594 12.0035C9.58594 12.1348 9.55997 12.2649 9.50952 12.3861C9.45907 12.5074 9.38514 12.6174 9.29199 12.71L3.51299 18.49L2.45299 17.43L7.87699 12.005L2.45199 6.58Z" fill="#0C2780"/>
                            </svg>
                        </div>
                        <Fade key={rinki} duration={300}>
                            {rinki && (                      
                                <div className={`absolute bg-[#CEDFF2] top-[100px] p-[13px] pr-[30px] flex flex-col gap-[13px]`}>
                                    <Link to="/markets-crypto"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/markets-crypto' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2.1')}</p></Link>
                                    <Link to="/products-arvest"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/products-arvest' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2.2')}</p></Link>
                                    <Link to="/stock"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/stock' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2.3')}</p></Link>
                                    <Link to="/indices"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/indices' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2.4')}</p></Link>
                                    <Link to="/currencies"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/currencies' ? 'font-[600]' : 'font-[400]'}`}>{t('header.2.5')}</p></Link>
                                </div>
                            )}
                        </Fade>
                    </div>
                    <div>
                        <div className="flex gap-[6px] cursor-pointer hover:scale-[1.1] transition-all" onClick={handleTorgClick}>
                            <p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/###' ? 'font-[600]' : 'font-[400]'}`}>{t('header.3')}</p>
                            <svg className={`mt-px transition-all ${torgi === true ? 'rotate-90' : ''}`} xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
                                <path d="M2.45199 6.58L3.51299 5.52L9.29199 11.297C9.38514 11.3896 9.45907 11.4996 9.50952 11.6209C9.55997 11.7421 9.58594 11.8722 9.58594 12.0035C9.58594 12.1348 9.55997 12.2649 9.50952 12.3861C9.45907 12.5074 9.38514 12.6174 9.29199 12.71L3.51299 18.49L2.45299 17.43L7.87699 12.005L2.45199 6.58Z" fill="#0C2780"/>
                            </svg>
                        </div>
                        <Fade key={torgi} duration={300}>
                            {torgi && (                      
                                <div className={`absolute bg-[#CEDFF2] top-[100px] p-[13px] pr-[30px] flex flex-col gap-[13px]`}>
                                    <Link to="/premium-service"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/premium-service' ? 'font-[600]' : 'font-[400]'}`}>{t('header.3.1')}</p></Link>
                                    <Link to="/trade-terminal"><p className={`manrope text-[#0C2780] text-[16px] ${location.pathname === '/trade-terminal' ? 'font-[600]' : 'font-[400]'}`}>{t('header.3.2')}</p></Link>
                                </div>
                            )}
                        </Fade>
                    </div>
                    <Link to="/accounts"><p className={`manrope hover:scale-[1.1] transition-all text-[#0C2780] text-[16px] ${location.pathname === '/accounts' ? 'font-[600]' : 'font-[400]'}`}>{t('header.4')}</p></Link>
                    <Link to="/about"><p className={`manrope hover:scale-[1.1] transition-all text-[#0C2780] text-[16px] ${location.pathname === '/about' ? 'font-[600]' : 'font-[400]'}`}>{t('header.5')}</p></Link>
                    <Link to="/academy"><p className={`manrope hover:scale-[1.1] transition-all text-[#0C2780] text-[16px] ${location.pathname === '/academy' ? 'font-[600]' : 'font-[400]'}`}>{t('header.6')}</p></Link>
                    <Dropdown
                        options={languages}
                        placeholder="EN"
                        onChange={handleChangeLang}
                        value={languages.find(lang => lang.value === currentLang)}
                        className="hover:scale-[1.1] transition-all"
                    />
                    <a href="https://user.arvest-solid.net">
                        <div className="button cursor-pointer hover:scale-[1.1] transition-all">
                            <p className="open-sans text-white text-[16px]">{t('header.button')}</p>
                        </div>
                    </a>
                </div>
                
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[60px]">
                <Link to="/"><img src={logo_mob} alt="" className="w-[50px]"/></Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                />
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
